import { useState } from "react";
import { Header } from "./components/Header";
import { HeroSection } from "./components/HeroSection";
import { AmenitiesSection } from "./components/AmenitiesSection";
import { RatesSection } from "./components/RatesSection";
import { AttractionsSection } from "./components/AttractionsSection";
import { FAQSection } from "./components/FAQSection";
import { ContactSection } from "./components/ContactSection";
import { Footer } from "./components/Footer";
import { StyleGuide } from "./components/StyleGuide";
import { Button } from "./components/ui/button";

export default function App() {
  const [showStyleGuide, setShowStyleGuide] = useState(false);

  if (showStyleGuide) {
    return (
      <div className="min-h-screen">
        <div className="fixed top-4 right-4 z-50">
          <Button 
            onClick={() => setShowStyleGuide(false)}
            variant="outline"
            className="bg-white shadow-lg"
          >
            Back to Website
          </Button>
        </div>
        <StyleGuide />
      </div>
    );
  }

  return (
    <div className="min-h-screen">
      <div className="fixed top-4 right-4 z-50">
        <Button 
          onClick={() => setShowStyleGuide(true)}
          variant="outline"
          className="bg-white shadow-lg text-xs"
        >
          View Style Guide
        </Button>
      </div>
      <Header />
      <main>
        <HeroSection />
        <AmenitiesSection />
        <RatesSection />
        <AttractionsSection />
        <FAQSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}